import React from "react";

function Screenshots({index, bgFromIndex}) {
  return (
    <section id="screenshots" className="screenshots-section"  style={{backgroundColor: bgFromIndex(index)}}>
      <div className="section-header"></div>
      <div className="screenshots">
        <img id="img1" src="/assets/unleash.png" alt="App Screenshot 1" />
        <img id="img2" src="/assets/three_levels.png" alt="App Screenshot 1" />
        <img id="img3"  src="/assets/thousands.png" alt="App Screenshot 1" />
      </div>
    </section>
  );
}

export default Screenshots;
